import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../components/Icon";
import { Button, Field } from "../components/ui";
import { API } from "../api";
import { useI18n } from "../i18n";
import { C } from "../theme";

export default function Forgot() {
  const { t: tr } = useI18n();
  const nav = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const request = async () => {
    setErr(""); setBusy(true);
    try {
      const res = await fetch(`${API}/auth/forgot-password`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email }) });
      const data = await res.json();
      setMsg(data.message); setStep(2);
    } catch { setErr(tr("forgot.wentWrong")); }
    finally { setBusy(false); }
  };

  const reset = async () => {
    setErr("");
    if (code.length !== 6 || pw.length < 6) { setErr(tr("forgot.errCode")); return; }
    setBusy(true);
    try {
      const res = await fetch(`${API}/auth/reset-password`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, code, new_password: pw }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.detail || tr("forgot.resetFailed"));
      nav("/login");
    } catch (e) { setErr(e?.message || tr("forgot.resetFailed")); }
    finally { setBusy(false); }
  };

  return (
    <div className="screen fade-up" style={{ padding: 24 }}>
      <button data-testid="forgot-back" className="pressable" onClick={() => nav(-1)} style={{ marginBottom: 12 }}>
        <Icon name="chevron-back" size={26} color={C.text} />
      </button>
      <h1 className="display" style={{ color: C.text, fontSize: 30, fontWeight: 900, margin: 0 }}>{tr("forgot.title")}</h1>
      {step === 1 ? (
        <>
          <div style={{ color: C.muted, fontSize: 15, marginTop: 8, marginBottom: 24, lineHeight: 1.4 }}>{tr("forgot.intro")}</div>
          <Field label={tr("auth.email")} testID="forgot-email" autoCapitalize="none" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
          {!!err && <div style={{ color: C.red, marginBottom: 12, fontWeight: 600 }}>{err}</div>}
          <Button title={tr("forgot.sendCode")} testID="forgot-send" onPress={request} loading={busy} disabled={!email} />
        </>
      ) : (
        <>
          <div style={{ color: C.muted, fontSize: 15, marginTop: 8, marginBottom: 24, lineHeight: 1.4 }}>{msg}</div>
          <Field label={tr("forgot.code")} testID="forgot-code" inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value)} placeholder="000000" maxLength={6} />
          <Field label={tr("forgot.newPassword")} testID="forgot-newpw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder={tr("forgot.newPasswordPh")} />
          {!!err && <div style={{ color: C.red, marginBottom: 12, fontWeight: 600 }}>{err}</div>}
          <Button title={tr("forgot.setNew")} testID="forgot-reset" variant="green" onPress={reset} loading={busy} />
        </>
      )}
    </div>
  );
}
